import { tw } from '@/utils/tw';
import BaseFactBox from 'base/components/FactBox/theme';

const { Prose } = BaseFactBox;

const FactBox = tw.theme({
  extend: BaseFactBox,
  slots: {
    base: 'rounded',
    headline: 'text-black text-headline-lg normal-case',
  },
});

export default Object.assign(FactBox, { Prose });
